<div class="text-align-center">
  <sb-stamp class="mb-4" [shadow]="'default-sm'" [type]="'fill-white'">
    <sb-icon [name]="'mic-on-fill'" [size]="'3'">
      <div class="bg-gradient-blue mix-blend-mode-screen fill-parent"></div>
    </sb-icon>
  </sb-stamp>
  <h3 class="t-5@r color-jet mb-4">Please Allow Access</h3>
  <div class="t-8@r color-ash mb-6">To send voice messages, you must allow access to your microphone.</div>
  <div class="grid">
    <button class="g-col-6" sbButton [size]="'big'" [stretchable]="true" [variant]="'ghost-cloud'" (click)="close()">
      Cancel
    </button>
    <button class="g-col-6" sbButton [size]="'big'" [stretchable]="true" [variant]="'fill-green'" (click)="confirm()">
      Allow
    </button>
  </div>
</div>
